export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    $('#banner-slick-slider')
      .slick({
        dots: true,
        dotsClass: 'vertical-dots',
        arrows: false,
        rows: 0,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        cssEase: 'linear',
        draggable: false,
        autoplay: true,
        autoplaySpeed: 5000,

      })
      .delay(100)
      .animate({'opacity':'1'}, 300);

    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js